import { createGlobalStyle } from "styled-components";

/* ─── Dark theme (par défaut) ─────────────────────────────────────────────── */
export const darkTheme = {
  name:        "dark",
  bg:          "#080a0c",
  bgCard:      "#0e1115",
  bgHover:     "#141820",
  fonNav:      "rgba(8,10,12,.78)",
  border:      "#1e2530",
  borderLight: "#2a3340",
  green:       "#00e676",
  greenDim:    "rgba(0,230,118,.13)",
  red:         "#ff3b5c",
  redDim:      "rgba(255,59,92,.13)",
  gold:        "#ffc107",
  accent:      "#4fc3f7",
  text:        "#e8edf2",
  textMuted:   "#5a6a7a",
    textNav:     "#e8edf2",
        bgAide:     "#1a1611",
  textDim:     "#8a9aaa",
  fontMono:    "\'DM Mono\', \'Courier New\', monospace",
  fontDisplay: "\'Playfair Display\', Georgia, serif",
  fontBody:    "\'Syne\', sans-serif",
};

/* ─── Light theme ─────────────────────────────────────────────────────────── */
/* Construit pour avoir le même équilibre de contraste/lisibilité que le dark,
   mais avec une identité propre — pas juste un dark inversé.
   Fond légèrement bleuté (pas blanc pur), cartes blanches nettes, accents
   recalibrés pour rester lisibles sur fond clair (vert/rouge plus saturés,
   accent bleu plus profond pour éviter l'effet "pastel délavé"). */
export const lightTheme = {
  name:        "light",
  bg:          "#f4f6f9",
  bgCard:      "#ffffff",
  bgHover:     "#eceff4",
  fonNav:      "rgba(255,255,255,.82)",
  border:      "#dfe3ea",
  borderLight: "#c7ccd6",
  green:       "#0a9e52",
  greenDim:    "rgba(10,158,82,.12)",
  red:         "#d62839",
  redDim:      "rgba(214,40,57,.1)",
  gold:        "#b8860b",
  accent:      "#1565c0",
  text:        "#131820",
  textMuted:   "#8b94a3",
  textNav:     "#4a5263",
          bgAide:     "#e8edf2",

  textDim:     "#4a5263",
  fontMono:    "\'DM Mono\', \'Courier New\', monospace",
  fontDisplay: "\'Playfair Display\', Georgia, serif",
  fontBody:    "\'Syne\', sans-serif",
};

/* ─── Rétrocompat — exporter darkTheme comme `theme` ─────────────────────── */
export const theme = darkTheme;

/* ─── GlobalStyle ─────────────────────────────────────────────────────────── */
export const GlobalStyle = createGlobalStyle`

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  html { font-size: 14px; scroll-behavior: smooth; }

  body {
    background: ${({ theme }) => theme.bg};
    color:      ${({ theme }) => theme.text};
    font-family:${({ theme }) => theme.fontBody};
    -webkit-font-smoothing: antialiased;
    min-height: 100vh;
    transition: background .25s ease, color .25s ease;
    background-image: ${({ theme }) => theme.name === "dark"
      ? "radial-gradient(ellipse 60% 40% at 70% 0%, #0d1a2a 0%, transparent 60%), radial-gradient(ellipse 40% 30% at 0% 80%, #0a1a10 0%, transparent 50%)"
      : "radial-gradient(ellipse 60% 40% at 70% 0%, rgba(21,101,192,.05) 0%, transparent 60%), radial-gradient(ellipse 40% 30% at 0% 80%, rgba(10,158,82,.04) 0%, transparent 50%)"};
  }

  ::selection {
    background: ${({ theme }) => theme.name === "dark" ? "rgba(0,230,118,.25)" : "rgba(25,118,210,.15)"};
  }

  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) => theme.border} transparent;

  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-track { background: transparent; }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.border};
    border-radius: 3px;
  }

  @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.4} }

  /* Transitions globales sur les éléments de fond */
  *, *::before, *::after {
    transition-property: background-color, border-color, color, box-shadow;
    transition-duration: .2s;
    transition-timing-function: ease;
  }
  /* Désactiver la transition sur les animations intentionnelles */
  [class*="animation"], canvas { transition: none !important; }
`;
